import React, { useContext } from "react";
import { DIMENSIONS } from "utils/Dimensions";

import SelectSheetPopup from "app/common/components/SelectSheetPopup";
import { observer } from "mobx-react";
import styled from "styled-components";
import TabNames from "./TabNames.js";
import { Box, CircularProgress } from "@material-ui/core";
import { PackStoreContext } from "app/Pack/PackStore.js";
import CreateSheet from "./CreateSheet.js";
import PackDashBoard from "./PackDashBoard.js";

function TabBar(props) {
  const store = useContext(PackStoreContext);

  return (
    <div
      className="d-flex align-items-center tab-bar"
      style={{
        minHeight: DIMENSIONS.header2,
        backgroundColor: props.themeColor,
        overflow: "auto",
        lineHeight: "normal",
        zIndex: 11,
      }}
    >
      <SelectSheetPopup
        sheets={props.sheets}
        selectedSheet={props.selectedSheet}
        onChange={props.changeSheet}
      />
      {store.pack?.is_dashboard_enabled === '1' && <PackDashBoard store={store} />}
      {props.sheets.length > 0 && (
        <Box display="flex">
          <TabNames
            sheets={props.sheets.filter(item => item.id !== 'dashboard')}
            selectedSheet={props.selectedSheet}
            renameSheet={props.renameSheet}
            themeColor={props.themeColor}
            changeSheet={props.changeSheet}
            deleteSheet={props.deleteSheet}
            openLogSheet={props.openLogSheet}
            duplicateSheet={props.duplicateSheet}
          />
        </Box>
      )}

      {store.isAdmin && (
        <div
          // key={index}
          className={"h-100 inactiveSheet"}
          style={{
            fontSize: 14,
            cursor: "pointer",
            display: "flex",
            marginLeft: 5,
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            borderTopLeftRadius: 2,
            borderTopRightRadius: 2,
            color: "#eee",
            paddingLeft: 15,
            paddingRight: props.isSheetCreating ? 15 : 0,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SheetName>
            {props.isSheetCreating ? (
              <>
                Creating Sheet... <CircularProgress size={11} color="inherit" />
              </>
            ) : (
              <CreateSheet></CreateSheet>
            )}
          </SheetName>
        </div>
      )}
    </div>
  );
}

export default observer(TabBar);

const SheetName = styled.span`
  display: inline-block;
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
